document.addEventListener('DOMContentLoaded', function() {
  function fixThumbnailImages() {
    // Target product thumbnails specifically
    const thumbnailImages = document.querySelectorAll('.product__thumb-item img');
    
    thumbnailImages.forEach(function(img) {
      img.style.minHeight = '0';
      img.style.objectFit = 'contain';
      img.style.height = 'auto';
      img.style.width = 'auto';
      img.style.maxHeight = '100%';
      img.style.maxWidth = '100%';
      img.style.position = 'static';
      img.style.margin = '0 auto';
      
      const container = img.closest('.product__thumb-item');
      if (container) {
        const aspectRatio = img.naturalWidth / img.naturalHeight;
        
        if (aspectRatio > 1.5) { 
          img.style.maxHeight = '70%';
          img.style.maxWidth = '95%';
        } else if (aspectRatio < 0.75) { 
          img.style.maxHeight = '95%';
          img.style.maxWidth = '75%';
        }
      }
    });
    
    // Ensure thumbnails display vertically beside the main image with full height
    const thumbContainers = document.querySelectorAll('.product__thumbs');
    thumbContainers.forEach(function(container) {
      container.style.overflow = 'hidden';
      
      // Force vertical layout for thumbnails
      container.classList.add('product__thumbs--beside');
      container.classList.remove('product__thumbs--below');
      
      // Get main image container height to match thumbnails container height
      const mainImageContainer = container.closest('.grid').querySelector('.product__main-photos');
      if (mainImageContainer) {
        const mainImageHeight = mainImageContainer.offsetHeight;
        
        // Set the thumbnail container to match the main image height
        container.style.height = mainImageHeight + 'px';
        container.style.maxHeight = 'none';
      }
      
      const scroller = container.querySelector('.product__thumbs--scroller');
      if (scroller) {
        // Apply vertical styling with full height
        scroller.style.flexDirection = 'column';
        scroller.style.display = 'flex';
        scroller.style.flexWrap = 'nowrap';
        scroller.style.overflowY = 'auto';
        scroller.style.overflowX = 'hidden';
        scroller.style.height = '100%'; // Full height of parent container
        scroller.style.maxHeight = 'none'; // Remove any height restriction
        scroller.style.width = 'auto';
      }
    });
    
    // Make sure thumbnail items work vertically with consistent sizing
    const thumbItems = document.querySelectorAll('.product__thumb-item');
    thumbItems.forEach(function(item) {
      item.style.width = '100%';
      item.style.maxWidth = '100px';
      item.style.height = '100px'; // Fixed height for consistency
      item.style.minHeight = '100px';
      item.style.marginRight = '0';
      item.style.marginBottom = '10px';
      item.style.display = 'flex';
      item.style.alignItems = 'center';
      item.style.justifyContent = 'center';
      item.style.flexShrink = '0'; // Prevent shrinking
    });
    
    // Make sure the product images container has the right layout
    const productLayoutContainers = document.querySelectorAll('.product-single__photos');
    productLayoutContainers.forEach(function(container) {
      if (container.parentElement) {
        container.parentElement.style.display = 'flex';
        container.parentElement.style.flexDirection = 'row';
        container.parentElement.style.alignItems = 'flex-start';
      }
    });
    
    fixProductSpacing();
  }
  
  function fixProductSpacing() {
    const productMetas = document.querySelectorAll('.grid-product__meta');
    productMetas.forEach(function(meta) {
      meta.style.padding = '3px 0 3px 0';
    });
    
    const productTitles = document.querySelectorAll('.grid-product__title');
    productTitles.forEach(function(title) {
      title.style.marginBottom = '2px';
      title.style.lineHeight = '1.1';
    });
    
    const vendors = document.querySelectorAll('.grid-product__vendor');
    vendors.forEach(function(vendor) {
      vendor.style.marginBottom = '2px';
      vendor.style.lineHeight = '1.1';
    });
    
    const prices = document.querySelectorAll('.grid-product__price');
    prices.forEach(function(price) {
      price.style.marginTop = '2px';
      price.style.lineHeight = '1.1';
    });
  }
  
  // Execute functions
  fixThumbnailImages();
  
  // Run on load to ensure images are loaded
  setTimeout(fixThumbnailImages, 500);
  window.addEventListener('load', fixThumbnailImages);
  
  // Also run on resize to handle window size changes
  window.addEventListener('resize', function() {
    setTimeout(fixThumbnailImages, 200);
  });
  
  const observer = new MutationObserver(function(mutations) {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        const hasRelevantChanges = Array.from(mutation.addedNodes).some(node => {
          return node.nodeType === 1 && (
            node.classList?.contains('product__thumb-item') ||
            node.querySelector?.('.product__thumb-item') ||
            node.classList?.contains('product__thumbs') ||
            node.querySelector?.('.product__thumbs') ||
            node.classList?.contains('product__main-photos') ||
            node.querySelector?.('.product__main-photos')
          );
        });
        
        if (hasRelevantChanges) {
          fixThumbnailImages();
          break;
        }
      }
    }
  });
  
  // Find product containers and only observe those, not header areas
  const productContainers = document.querySelectorAll('.product-single, .product-template');
  productContainers.forEach(container => {
    if (container) {
      observer.observe(container, {
        childList: true,
        subtree: true
      });
    }
  });
});